/**
 * token操作封装
 */
import { TOKEN_CACHE_NAME } from '@/config/setting';
import { StorageUtil } from './lzd-util';

/**
 * 获取缓存的token
 */
export function getToken(): string | null {
  return StorageUtil.get(TOKEN_CACHE_NAME);
}

/**
 * 缓存token
 * @param token token
 * @param remember 是否永久存储
 */
export function setToken(token?: string, remember?: boolean) {
  removeToken();
  if (token) {
    StorageUtil.set(TOKEN_CACHE_NAME, token);
  }
}

/**
 * 移除token
 */
export function removeToken() {
  StorageUtil.remove(TOKEN_CACHE_NAME);
}
